import { useTranslation } from 'react-i18next'
import { Col, Row, Skeleton } from 'antd'

import Page from '../../Page'
import styles from './ConfigurationFormSkeleton.module.scss'

const ConfigurationFormSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Page pageTitle={t('configuration.view.title')}>
      <div>
        <div className="form-title">{t('configuration.form.title')}</div>
        <Row gutter={[20, 36]} style={{ marginTop: '40px' }}>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
          <Col span={24}>
            <Skeleton.Input active className={styles.configurationTextarea} />
          </Col>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
        </Row>
        <Row gutter={[20, 5]} className={styles.actions}>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
          <Col span={24} lg={{ span: 12 }}>
            <Skeleton.Input active className={styles.configurationInput} />
          </Col>
        </Row>
      </div>
    </Page>
  )
}

export default ConfigurationFormSkeleton
